import { InjectionToken } from '@angular/core';

/**
 * When true (vendor app), product GET requests use skipPriceMarkup so vendors see DB CartCo prices.
 */
export const PRODUCTS_SKIP_VENDOR_MARKUP = new InjectionToken<boolean>(
  'PRODUCTS_SKIP_VENDOR_MARKUP',
  { providedIn: 'root', factory: () => false },
);

/**
 * When true (user app), product catalog GETs hide expired products/variants.
 * Vendor and POS keep expired SKUs visible for inventory / sale-blocking UI.
 */
export const PRODUCTS_EXCLUDE_EXPIRED = new InjectionToken<boolean>(
  'PRODUCTS_EXCLUDE_EXPIRED',
  { providedIn: 'root', factory: () => false },
);
